<sc-flex vertical stretchContent fitHeight>
  <sc-title>
    <sc-dictionary-label dictionaryKey="tmc.admin.yard-structure.stationset-details.title"></sc-dictionary-label>
  </sc-title>
  <sc-content-spacer vertical></sc-content-spacer>
  <div>
    <div class="stationset-station">
      <div class="stationset-header">
        <div class="header-fields-container">
          <mat-form-field style="grid-column: 1 / span 1; grid-row: 1 / span 1;" appearance="fill">
            <mat-label>
              <sc-dictionary-label dictionaryKey="tmc-yard.stationgroup.ui.stationset.externalKey.label"></sc-dictionary-label>
            </mat-label>
            <input [(ngModel)]="stationSet.externalKey" #ctrlExternalKey="ngModel" name="{{'stationSetExternalKey'}}"
              matInput [required]="true" [maxlength]="50" [minlength]="1" />
          </mat-form-field>
          <mat-form-field style="grid-column: 2 / span 2; grid-row:  1 / span 1;" appearance="fill">
            <mat-label>
              <sc-dictionary-label dictionaryKey="tmc-yard.common.name"></sc-dictionary-label>
            </mat-label>
            <input [(ngModel)]="stationSet.name" #ctrlName="ngModel" name="{{'stationSetName'}}" matInput
              [required]="true" [maxlength]="255" />
          </mat-form-field>
          <mat-form-field style="grid-column: 4 / span 1; grid-row: 1 / span 1;" appearance="fill">
            <mat-label>
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.stationgroup.stationset.internal"></sc-dictionary-label>
            </mat-label>
            <input [(ngModel)]="stationSet.internal" #ctrlName="ngModel" name="{{'stationSetInternal'}}" matInput
              [required]="false" [maxlength]="255" />
          </mat-form-field>
          <mat-form-field style="grid-column: 5 / span 1; grid-row: 1 / span 1;" appearance="fill">
            <mat-label>
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.stationgroup.stationset.referenceDuration.label"></sc-dictionary-label>
            </mat-label>
            <input [(ngModel)]="stationSet.referenceDuration" #ctrlReferenceDurationKey="ngModel"
              name="{{'referenceDuration'}}" matInput appPositiveInteger type="number" min="0" />
          </mat-form-field>
          <mat-form-field style="grid-column: 1; grid-row: 2 / span 1;" appearance="fill">
            <mat-label>
              <sc-dictionary-label dictionaryKey="tmc-yard.entity.station-set.station-set-type"></sc-dictionary-label>
            </mat-label>
            <mat-select [(ngModel)]="stationSet.stationSetType" name="stationSetType">
              <mat-option *ngFor="let o of stationSetTypes" value="{{o}}">
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.station-set.station-set-type.{{o}}"></sc-dictionary-label>
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field style="grid-column: 2 / span 4; grid-row: 2 / span 1;" appearance="fill">
            <mat-label>
              <sc-dictionary-label dictionaryKey="tmc-yard.common.description"></sc-dictionary-label>
            </mat-label>
            <textarea cdkTextareaAutosize [(ngModel)]="stationSet.description" name="{{'stationSetDescription'}}"
              matInput [required]="false" [maxlength]="255">
        </textarea>
          </mat-form-field>
        </div>
        <!-- Show error messages -->
        <div class="table-row">
          <app-service-response [responseMessages]="responseMessages"></app-service-response>
        </div>
      </div>

      <sc-content-spacer vertical></sc-content-spacer>
    </div>
  </div>
  <sc-flex-fitting-content vertical>

    <mat-tab-group>
      <mat-tab
        label="{{'stations' | translate: ['tmc-yard.ui.admin.stationgroup.stationset.tab.stations', translationService.language, translationService.revision]}}">

        <sc-scroll-pane>
          <div class="station-list" cdkDropList (cdkDropListDropped)="dropStation($event)">

            <div class="draggable-form-box station" cdkDrag *ngFor="let station of stationSet.stations">

              <mat-form-field class="station-name " appearance="fill">
                <mat-label>
                  <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.stationgroup.stationset.stations.table.column.name"></sc-dictionary-label>
                </mat-label>
                <input matInput [(ngModel)]="station.name" [ngModelOptions]="{standalone: true}"
                  [readonly]="true">
              </mat-form-field>

              <mat-form-field class="station-description " appearance="fill">
                <mat-label>
                  <sc-dictionary-label dictionaryKey="tmc-yard.common.description"></sc-dictionary-label>
                </mat-label>
                <input matInput [(ngModel)]="station.description" [ngModelOptions]="{standalone: true}"
                  [readonly]="true">
              </mat-form-field>

              <div class="delete-button-wrapper">
                <sc-icon iconClass="fa-trash" (click)="removeStationFromStationSet(station)"></sc-icon>
              </div>
            </div>
            <div class="button-wrapper">
              <button class="add-button" mat-flat-button type="button" (click)="addStationToStationSet()">
                <sc-icon iconClass="fa-plus fa-2x"></sc-icon>
              </button>
            </div>
          </div>
        </sc-scroll-pane>

      </mat-tab>
      <mat-tab label="{{'backup structures' | translate: ['tmc-yard.ui.admin.stationgroup.stationset.tab.backup-structures',
      translationService.language, translationService.revision]}}">

        <sc-padding>

          <app-backup-reference [reference]="backupStationSet" *ngFor="let backupStationSet of stationSet.backupStationSets" (onDelete)="removeBackupStationSet($event)"></app-backup-reference>

          <sc-content-spacer vertical></sc-content-spacer>
          <sc-flex [centered]="true">
            <button class="add-button" mat-flat-button type="button" (click)="addBackupStationSet()">
              <sc-icon iconClass="fa-plus fa-2x"></sc-icon>
            </button>
          </sc-flex>

        </sc-padding>

      </mat-tab>
    </mat-tab-group>

  </sc-flex-fitting-content>
</sc-flex>
<!-- Loading spinner to prevent user from doing anything during validation. -->
<div class="loading-spinner" *ngIf="requestRunning">
  <i class="spinner fa-light fa-spinner fa-spin"></i>
</div>
